'use client';

import { IconButton, PrimaryButtonMT, RoundButton } from '@/components/buttons/Buttons';
import ExpensesCodeModal from '@/components/program/ExpensesCodeModal';
import LocationModal from '@/components/program/LocationModal';
import RideTypeModal from '@/components/program/RideTypeModal';
import TimeModal from '@/components/program/TimeModal';
import routes from '@/constants/routes';
import {
	travelProgramInitialValues,
	travelProgramSchema,
} from '@/modules/account/engine/travel-program.model';
import ConfirmationDialogHeader from '@/modules/confirmation/components/ConfirmationDialogHeader';
import { showConfirmationDialog } from '@/modules/confirmation/engines/confirmation.library';
import { showNotification } from '@/modules/notification/engine/notification.library';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { FaCar, FaClock } from 'react-icons/fa';
import { MdArrowBack, MdPinDrop, MdReceiptLong } from 'react-icons/md';
import EditProgramForm from '../components/EditProgramForm';
import style from './program.module.css';

interface Group {
	name: string;
	description: string;
	peopleCount: number;
}

const EditProgramScreen = () => {
	const [showExpensesCodeModal, setShowExpensesCodeModal] = useState(false);
	const [showLocationModal, setShowLocationModal] = useState(false);
	const [showTimeModal, setShowTimeCodeModal] = useState(false);
	const [showRideTypeModal, setShowRideTypeModal] = useState(false);

	// TODO: This is a temporary integration, remove or
	// refactor once react-hook-form is implemented.
	const methods = useForm({
		defaultValues: travelProgramInitialValues,
		resolver: yupResolver(travelProgramSchema),
	});

	const navigate1 = useNavigate();


	const navigate = () => {
		navigate1(routes['/programs/id']);
	};

	const rules = [
		{
			icon: <MdReceiptLong className="text-primary" size={24} />,
			title: 'Full coverage of trip expenses',
			value: 'Expense code required',
			onClick: () => {
				setShowExpensesCodeModal(true);
			},
		},
		{
			icon: <MdPinDrop className="text-primary" size={24} />,
			title: 'Locations',
			value: 'Xpress Brixton (#3 Brixton building, Three Brixton st. Brgy. Kapitolyo, Pasig City, Metro Manila, Philippines) 3km radius',
			onClick: () => {
				setShowLocationModal(true);
			},
		},
		{
			icon: <FaClock className="text-primary" size={24} />,
			title: 'Time',
			value: '08:00 am - 06:00 pm (10) hours [Mon, Tue, Wed, Thu, Fri]',
			onClick: () => {
				setShowTimeCodeModal(true);
			},
		},
		{
			icon: <FaCar className="text-primary" size={24} />,
			title: 'Ride type',
			value: 'Limited ride types (4 selected)',
			onClick: () => {
				setShowRideTypeModal(true);
			},
		},
	];

	const groups: Group[] = [
		{
			name: 'Product Team',
			description: 'Design, BAs, and QAs',
			peopleCount: 5,
		},
	];

	const handleCancelEditProgram = () =>
		showConfirmationDialog(discardMessage, {
			accept: navigate,
			acceptLabel: 'Discard Changes',
			rejectLabel: 'Cancel',
			header: discardHeaderTemplate,
			acceptClassName: '!bg-error',
		});

	const discardMessage =
		'You have unsaved changes. Are you sure you want to discard your changes?';

	const discardHeaderTemplate = (
		<ConfirmationDialogHeader
			message={'Discard changes?'}
			severity="warning"
		/>
	);

	const handleSubmit = () => {
		const notificationMessage = 'Program successfully updated.';

		navigate();
		showNotification(notificationMessage);
	};

	return (
		<FormProvider {...methods}>
			<form noValidate>
				<div className="pb-6">
					<div className="flex items-center mb-5">
						<IconButton
							id="back-btn"
							icon={
								<MdArrowBack
									size={24}
									className="text-primary mr-2"
								/>
							}
							label="Back"
							className={style.programBackButton}
							onClick={handleCancelEditProgram}
							type="button"
						/>
					</div>

					<EditProgramForm groups={groups} rules={rules} />

					<div className="flex pt-6">
						<PrimaryButtonMT
							id="edit-program"
							label="Save"
							className={style.programEditButton}
							onClick={handleSubmit}
						/>
					</div>
				</div>
				<ExpensesCodeModal
					visible={showExpensesCodeModal}
					setVisible={setShowExpensesCodeModal}
					onHide={() => setShowExpensesCodeModal(false)}
				/>
				<LocationModal
					visible={showLocationModal}
					setVisible={setShowLocationModal}
					onHide={() => setShowLocationModal(false)}
				/>
				<TimeModal
					visible={showTimeModal}
					setVisible={setShowTimeCodeModal}
					onHide={() => setShowTimeCodeModal(false)}
				/>
				<RideTypeModal
					visible={showRideTypeModal}
					setVisible={setShowRideTypeModal}
					onHide={() => setShowRideTypeModal(false)}
				/>
			</form>
		</FormProvider>
	);
};

export default EditProgramScreen;
